export class SendRequestProcedureForm {
    tempId: string;
    cuitNumber:string;
    comments:string='';
    procedureType:string;
    vehicleId:string;

    constructor(other ?:SendRequestProcedureForm) {
        if (other) {
            this.tempId = other.tempId;
            this.cuitNumber = other.cuitNumber;
            this.comments = other.comments;
            this.procedureType = other.procedureType;
            this.vehicleId = other.vehicleId;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/sendRequestProcedureForm.ts
 **/